import styled, { css } from "styled-components";

export const Container = styled.div`
  box-shadow: 0 0 5px 5px rgb(0 0 0 / 3%);
  border-radius: 10px;
  margin-bottom: 40px;
  position: relative;
  min-height: 150px;

  border-color: transparent;
  background: ${({ theme }) => theme.colors.modalBackgroundColor};

  h1 {
    padding: 1rem 1.5rem;
    font-size: 20px;
    font-weight: 400;

    color: ${({ theme }) => theme.colors.textColor};
    border-bottom: 1px solid ${({ theme }) => theme.colors.backgroundColor};
  }

  .bundles {
    width: 100%;
    padding: 0 25px 5px;

    .slider_container {
      width: 100%;
      overflow-x: hidden;
      overflow-y: visible;
      padding-bottom: 200px;
      margin-bottom: -200px;
    }
  }
`;
